export default __webpack_public_path__ + "static/media/vergrootglas.a4b009c5.svg";